import React from "react";

import { Outlet } from "react-router-dom";

import { useInitAuth } from "@mightybot/core";

import { useAuthRouterObserver } from "../hooks/useAuthRouterObserver";
import MetaTags from "../utils/MetaTags";

function RootRoute() {
	useInitAuth();
	// Watches the auth slice for session-end signals dispatched by base.ts and
	// performs the soft navigation that used to be a hard `window.location.href`
	// reload. Mounting here covers every route subtree.
	useAuthRouterObserver();
	return (
		<React.Fragment>
			<MetaTags />
			<Outlet />
		</React.Fragment>
	);
}

export default RootRoute;
